<template>
  <teleport to="body">
    <div
        v-if="isOpen"
        class="imagePreview"
        role="dialog"
        aria-modal="true"
        @click="closeImagePreview"
    >
      <button
          class="imagePreview__close"
          type="button"
          title="Закрыть"
          aria-label="Закрыть"
          @click.stop="closeImagePreview"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <img
          v-if="imageSrc"
          class="imagePreview__image"
          :src="imageSrc"
          alt=""
          @click.stop
      />
    </div>
  </teleport>
</template>

<script>
import {useImagePreview} from "@/composables/image-preview";

export default {
  name: "ImagePreviewModal",
  setup() {
    const {isOpen, imageSrc, closeImagePreview} = useImagePreview();
    return {isOpen, imageSrc, closeImagePreview};
  },
  methods: {
    onKeydown(e) {
      if (e.key === 'Escape' && this.isOpen) {
        // Не даём тому же Esc закрыть модалку редактирования, которая лежит ниже.
        e.stopImmediatePropagation();
        this.closeImagePreview();
      }
    },
    lockBodyScroll(lock) {
      if (lock) {
        // Запоминаем предыдущее значение: админская модалка тоже блокирует скролл,
        // и после закрытия предпросмотра его нельзя сбрасывать.
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return;
      }
      document.body.style.overflow = this.previousOverflow || '';
    },
  },
  data() {
    return {
      previousOverflow: '',
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeydown);
    this.lockBodyScroll(false);
  },
  watch: {
    isOpen(val) {
      this.lockBodyScroll(val);
    },
  },
}
</script>

<style scoped lang="scss">
.imagePreview {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: rgba(0, 0, 0, 0.8);
  cursor: zoom-out;
  // Админская модалка ставит body { pointer-events: none }, поэтому явно
  // возвращаем обработку кликов, иначе кнопка закрытия и фон не работают.
  pointer-events: auto;

  @include respond-to('md') {
    padding: 16px;
  }

  &__image {
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
    cursor: default;
    border-radius: 8px;
  }

  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
    background: transparent;
    border: none;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 8px;
    transition: color 0.3s;

    &:hover {
      color: var(--cd-danger);
    }
  }
}
</style>
